/**
 * WPA 客戶列表排序：customerNo ASC，再 branchNo ASC（與後端 Commerce 列表一致）。
 */
export function sortWpaCustomers(customers) {
  if (!Array.isArray(customers)) return [];
  return [...customers].sort((a, b) => {
    const cnA = String(a?.customerNo ?? '').trim();
    const cnB = String(b?.customerNo ?? '').trim();
    if (cnA !== cnB) {
      return cnA.localeCompare(cnB, undefined, { numeric: true, sensitivity: 'base' });
    }
    const brA = String(a?.branchNo ?? '').trim();
    const brB = String(b?.branchNo ?? '').trim();
    return brA.localeCompare(brB, undefined, { numeric: true, sensitivity: 'base' });
  });
}
